<main id="main" class="main">
  <div class="mainScreen">
    <!-- Supplier list -->
    <div class="row">
      <div
        class="form-group col-12 col-md-12 d-flex justify-content-between"
        style="background: #142a49 !important; font-size: 14px"
      >
        <h6 style="background-color: #142a49" class="admintitle">
          Suppliers&nbsp;<i class="bi bi-info-circle"></i>
        </h6>
        <div style="margin: 2px">
          <button class="addgroupadmininfoemp" (click)="addSupplier()">
            +&nbsp;{{ lang.Add_New }}
          </button>
        </div>
      </div>
    </div>
    <div class="table-responsive mt-2" style="margin-bottom: 48px">
      <table
        *ngIf="supplierList.length > 0"
        #dtElement
        datatable
        [dtOptions]="dtOptions"
        [dtTrigger]="dtTrigger"
        style="
          width: 100%;
          border-collapse: collapse;
          font-family: Arial, sans-serif;
          border: 1px solid #b9b9b9;
          font-size: 12px;
        "
      >
        <thead>
          <tr style="background-color: #808285; color: white; height: 29px">
            <th style="padding: 2px 8px; width: 8%; background-color: #808285">
              S.No
            </th>
            <th style="padding: 2px 8px; width: 12%; background-color: #808285">
              Supplier ID
            </th>
            <th
              style="
                padding: 2px 8px;
                width: 16%;
                text-align: center;
                background-color: #808285;
              "
            >
              Supplier Name
            </th>
            <th
              style="
                padding: 2px 8px;
                width: 16%;
                text-align: center;
                background-color: #808285;
              "
            >
              Supplier Contact
            </th>
            <th
              style="
                padding: 2px 8px;
                width: 12%;
                text-align: center;
                background-color: #808285;
              "
            >
              Products
            </th>
            <th
              style="
                padding: 2px 8px;
                width: 12%;
                text-align: center;
                background-color: #808285;
              "
            >
              Subscriber Count
            </th>
            <th
              style="
                padding: 2px 8px;
                width: 12%;
                text-align: center;
                background-color: #808285;
              "
            >
              Monthly Premium
            </th>
            <!-- <th
              style="
                padding: 2px 8px;
                width: 8%;
                text-align: center;
                background-color: #808285;
              "
            >
              Status
            </th> -->
            <th
              style="
                padding: 2px 8px;
                width: 8%;
                text-align: center;
                background-color: #808285;
              "
            >
              Action
            </th>
          </tr>
        </thead>

        <tbody>
          <tr
            *ngFor="let supplier of supplierList; let i = index"
            style="background-color: #f6f6f6; height: 29px; font-size: 14px"
          >
            <td style="padding: 2px 8px">{{ i + 1 }}</td>
            <td style="padding: 2px 8px">{{ supplier?.supplierId }}</td>
            <td
              style="
                text-align: center;
                vertical-align: middle;
                padding: 2px 8px;
              "
            >
              {{ supplier.supplierName }}
            </td>

            <!-- Supplier Contact -->
            <td
              style="
                text-align: center;
                vertical-align: middle;
                padding: 2px 8px;
              "
            >
              <div
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  gap: 6px;
                  flex-wrap: wrap;
                "
              >
                <span>{{ supplier?.contactInfo[0]?.firstName }}</span>
                <button
                  class="fontSize"
                  style="
                    background-color: #142a49;
                    color: white;
                    border: 1px solid #fff;
                    border-radius: 6px;
                    padding: 2px 8px;
                    font-size: 12px;
                    font-family: Arial, sans-serif;
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    cursor: pointer;
                  "
                  (click)="openContactList(supplier.contactInfo, supplier.id)"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="#ffffff"
                    style="vertical-align: middle"
                  >
                    <path
                      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 
          10 10-4.48 10-10S17.52 2 12 2zm1 
          17h-2v-6h2v6zm0-8h-2V7h2v4z"
                    />
                  </svg>
                  {{ supplier.contactInfo?.length }}
                </button>
              </div>
            </td>

            <!-- Products -->
            <td
              style="
                text-align: center;
                padding: 2px 8px;
                vertical-align: middle;
              "
            >
              <div
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <button
                  class="fontSize"
                  style="
                    background-color: #142a49;
                    color: white;
                    border: 1px solid #fff;
                    border-radius: 6px;
                    padding: 2px 8px;
                    font-size: 12px;
                    font-family: Arial, sans-serif;
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    cursor: pointer;
                  "
                  (click)="openProductList(supplier.products, supplier.id)"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="#ffffff"
                    style="vertical-align: middle"
                  >
                    <path
                      d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 
          11-7-4-7-11-7zm0 12c-2.8 0-5-2.2-5-5s2.2-5 
          5-5 5 2.2 5 5-2.2 5-5 5zm0-8c-1.7 0-3 1.3-3 
          3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3z"
                    />
                  </svg>
                  {{ supplier.products.length }}
                </button>
              </div>
            </td>

            <td style="text-align: center; padding: 2px 8px">0</td>
            <td style="text-align: center; padding: 2px 8px">0</td>

            <!-- Status -->
            <!-- <td style="text-align: center; padding: 2px 8px">
              <span
                [ngClass]="{
                  'text-success': supplier.status === 'Active',
                  'text-danger': supplier.status === 'Inactive'
                }"
              >
                Inactive
              </span>
            </td> -->

            <!-- Actions -->
            <td style="text-align: center; padding: 2px 8px">
              <button
                (click)="editEntireSupplier(supplier)"
                style="
                  background-color: #2ca46c;
                  border: none;
                  border-radius: 6px;
                  cursor: pointer;
                  margin-right: 5px;
                  color: white;
                  padding: 2px 8px;
                  font-size: 12px;
                "
              >
                <i class="bi bi-pencil-fill"></i>
              </button>
              <button
                (click)="
                  triggerDeleteSupplierModal({
                    id: supplier.id,
                    name: supplier.supplierName
                  })
                "
                style="
                  background-color: #6b1004;
                  border: none;
                  border-radius: 6px;
                  cursor: pointer;
                  color: white;
                  padding: 1px 8px;
                  font-size: 12px;
                "
              >
                <i class="bi bi-trash-fill"></i>
              </button>
            </td>
          </tr>

          <!-- No data fallback -->
          <tr *ngIf="supplierList.length === 0" style="height: 29px">
            <td
              colspan="9"
              style="padding: 4px 8px; color: #333; text-align: center"
            >
              No Data available!
            </td>
          </tr>
        </tbody>
      </table>
      <!-- No data fallback -->
      <div *ngIf="loading" class="wrap">
        <div class="card" role="status" aria-live="polite">
          <div class="spinner" aria-hidden="true"></div>
          <p class="title">Loading…</p>
        </div>
      </div>
      <tr *ngIf="supplierList.length === 0" style="height: 29px">
        <td
          colspan="9"
          style="padding: 4px 8px; color: #333; text-align: center"
        >
          No Data available!
        </td>
      </tr>
      <!-- Contact Info Modal -->
      <div
        *ngIf="showContactModal"
        class="modal"
        tabindex="-1"
        style="display: block; background: rgba(0, 0, 0, 0.5)"
      >
        <div class="modal-dialog modal-lg" style="margin-top: 120px">
          <div class="modal-content">
            <!-- Header -->
            <div class="modal-header">
              <h5 class="modal-title" style="font-size: 15px; font-weight: 500">
                Contact Information
              </h5>
              <button
                type="button"
                class="custom-close-btn"
                (click)="closeModal()"
                aria-label="Close"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill="white"
                    d="M2.146 2.146a.5.5 0 0 1 .708 0L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854a.5.5 0 0 1 0-.708z"
                  />
                </svg>
              </button>
            </div>

            <!-- Body -->
            <div class="modal-body p-3">
              <!-- Button Row -->
              <div
                style="
                  display: flex;
                  justify-content: flex-end;
                  margin-bottom: 2px;
                "
              >
                <button
                  class="btn btn-success btn-sm"
                  style="
                    font-size: 13px;
                    padding: 4px 12px;
                    border-radius: 4px;
                    background-color: #fff;
                    color: #142a49;
                  "
                  (click)="addNewContact()"
                >
                  + Add New
                </button>
              </div>

              <!-- Table -->
              <div class="table-responsive">
                <table
                  style="
                    width: 100%;
                    border-collapse: collapse;
                    font-family: Arial, sans-serif;
                    border: 1px solid #b9b9b9;
                    font-size: 12px;
                  "
                >
                  <thead>
                    <tr
                      style="
                        background-color: #808285;
                        color: white;
                        height: 29px;
                      "
                    >
                      <th style="text-align: left; padding: 2px 8px">
                        First Name
                      </th>
                      <th style="text-align: left; padding: 2px 8px">
                        Last Name
                      </th>
                      <th style="text-align: left; padding: 2px 8px">Email</th>
                      <th style="text-align: left; padding: 2px 8px">Phone</th>
                      <th style="text-align: left; padding: 2px 8px">Role</th>
                      <th style="text-align: left; padding: 2px 8px">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let contact of contacts; let i = index"
                      style="
                        background-color: #f6f6f6;
                        height: 29px;
                        font-size: 14px;
                      "
                    >
                      <td style="text-align: left; padding: 2px 8px">
                        {{ contact.firstName }}
                      </td>
                      <td style="text-align: left; padding: 2px 8px">
                        {{ contact.lastName }}
                      </td>
                      <td style="text-align: left; padding: 2px 8px">
                        {{ contact.email }}
                      </td>
                      <td style="text-align: left; padding: 2px 8px">
                        {{ contact.phone }}
                      </td>
                      <td style="text-align: left; padding: 2px 8px">
                        {{ contact.role }}
                      </td>
                      <td style="text-align: left; padding: 2px 8px">
                        <button
                          (click)="editContact(i)"
                          style="
                            background-color: #2ca46c;
                            border: none;
                            border-radius: 6px;
                            cursor: pointer;
                            margin-right: 5px;
                            color: white;
                            padding: 2px 8px;
                            font-size: 12px;
                          "
                        >
                          <i class="bi bi-pencil-fill"></i>
                        </button>
                        <button
                          (click)="
                            onConfirmDeleteContact(
                              contact.id,
                              selectedSupplierId,
                              contact.firstName
                            )
                          "
                          style="
                            background-color: #b31616;
                            border: none;
                            border-radius: 6px;
                            cursor: pointer;
                            color: white;
                            padding: 2px 8px;
                            font-size: 12px;
                          "
                        >
                          <i class="bi bi-trash-fill"></i>
                        </button>
                      </td>
                    </tr>

                    <!-- No data fallback -->
                    <tr *ngIf="contacts.length === 0" style="height: 29px">
                      <td colspan="6" style="padding: 4px 8px; color: #333">
                        No Contact Information Available!
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Add Contact Information Popup-->
            <div
              *ngIf="showAddContactModal"
              class="modal fade show d-block"
              data-bs-backdrop="static"
              id="basicModal1"
              tabindex="-1"
              style="background: rgba(0, 0, 0, 0.5)"
            >
              <div
                style="width: 400px"
                class="modal-dialog modal-dialog-centered"
              >
                <div class="modal-content">
                  <!-- Header -->
                  <div
                    style="
                      background-color: #142a49;
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                    "
                  >
                    <h6 style="margin: 6px; background-color: #142a49">
                      Add Contact
                    </h6>
                    <button
                      (click)="onCloseAddContactPopup()"
                      style="margin: 3px"
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>

                  <!-- Body -->
                  <div class="modal-body">
                    <form class="onbordingform">
                      <!-- First row -->
                      <div style="display: flex; column-gap: 10px; width: 100%">
                        <!-- First Name -->
                        <div>
                          <label class="fontSize">{{ lang.First_Name }}</label
                          ><br />
                          <input
                            type="text"
                            [ngModelOptions]="{ standalone: true }"
                            [(ngModel)]="firstName"
                            placeholder="{{ lang.First_Name }}"
                            [formControl]="contactForm.controls['firstName']"
                            style="
                              width: 100%;
                              height: 30px;
                              padding: 6px 10px;
                              font-size: 14px;
                              border: 1px solid #ccc;
                              border-radius: 6px;
                              outline: none;
                              background-color: #e8eaf0;
                              box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                              transition: box-shadow 0.2s ease,
                                border-color 0.2s ease;
                              text-transform: capitalize;
                            "
                            onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                            onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                          />
                          <div
                            class="error"
                            *ngIf="
                              submitted &&
                              contactForm.controls['firstName'].errors
                            "
                          >
                            First name is required
                          </div>
                        </div>

                        <!-- Last Name -->
                        <div>
                          <label class="fontSize">{{ lang.Last_Name }}</label
                          ><br />
                          <input
                            type="text"
                            [ngModelOptions]="{ standalone: true }"
                            [(ngModel)]="lastName"
                            placeholder="{{ lang.Last_Name }}"
                            [formControl]="contactForm.controls['lastName']"
                            style="
                              width: 100%;
                              height: 30px;
                              padding: 6px 10px;
                              font-size: 14px;
                              border: 1px solid #ccc;
                              border-radius: 6px;
                              outline: none;
                              background-color: #e8eaf0;
                              box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                              transition: box-shadow 0.2s ease,
                                border-color 0.2s ease;
                              text-transform: capitalize;
                            "
                            onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                            onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                          />
                          <div
                            class="error"
                            *ngIf="
                              submitted &&
                              contactForm.controls['lastName'].errors
                            "
                          >
                            Last name is required
                          </div>
                        </div>
                      </div>

                      <!-- Second row -->
                      <div style="display: flex; column-gap: 10px; width: 100%">
                        <!-- Email -->
                        <div>
                          <label class="fontSize">{{ lang.Email }}</label
                          ><br />
                          <input
                            type="text"
                            [ngModelOptions]="{ standalone: true }"
                            [(ngModel)]="email"
                            placeholder="{{ lang.Email }}"
                            [formControl]="contactForm.controls['email']"
                            style="
                              width: 100%;
                              height: 30px;
                              padding: 6px 10px;
                              font-size: 14px;
                              border: 1px solid #ccc;
                              border-radius: 6px;
                              outline: none;
                              background-color: #e8eaf0;
                              box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                              transition: box-shadow 0.2s ease,
                                border-color 0.2s ease;
                              text-transform: lowercase;
                            "
                            onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                            onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                          />
                          <div
                            class="error"
                            *ngIf="
                              submitted && contactForm.controls['email'].errors
                            "
                          >
                            <span
                              *ngIf="
                                contactForm.controls['email'].errors?.required
                              "
                              >Email is required</span
                            >
                            <span
                              *ngIf="
                                contactForm.controls['email'].errors?.email
                              "
                              >Invalid email format</span
                            >
                          </div>
                        </div>

                        <!-- Phone -->
                        <div>
                          <label class="fontSize">{{ lang.Phone_Number }}</label
                          ><br />
                          <input
                            type="text"
                            [ngModelOptions]="{ standalone: true }"
                            [(ngModel)]="phone"
                            (keydown)="
                              allowOnlyNumbersForPhoneNumber($event, phone)
                            "
                            [formControl]="contactForm.controls['phone']"
                            max="10"
                            placeholder="{{ lang.Phone_Number }}"
                            style="
                              width: 100%;
                              height: 30px;
                              padding: 6px 10px;
                              font-size: 14px;
                              border: 1px solid #ccc;
                              border-radius: 6px;
                              outline: none;
                              background-color: #e8eaf0;
                              box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                              transition: box-shadow 0.2s ease,
                                border-color 0.2s ease;
                              text-transform: capitalize;
                            "
                            onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                            onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                          />
                          <div
                            class="error"
                            *ngIf="
                              submitted && contactForm.controls['phone'].errors
                            "
                          >
                            <span
                              *ngIf="
                                contactForm.controls['phone'].errors?.required
                              "
                            >
                              Phone number is required
                            </span>
                            <span
                              *ngIf="
                                contactForm.controls['phone'].errors?.pattern
                              "
                            >
                              Phone number must be exactly 10 digits
                            </span>
                          </div>
                        </div>
                      </div>

                      <!-- Third row -->
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          /* flex-wrap: wrap; */
                          column-gap: 10px;
                          width: 100%;
                          margin-top: 2px;
                        "
                      >
                        <!-- Role -->
                        <div style="display: flex; flex-direction: column">
                          <label class="fontSize">{{ lang.Roles }}</label>
                          <select
                            [(ngModel)]="role"
                            [ngModelOptions]="{ standalone: true }"
                            (change)="onRoleChange($event)"
                            [formControl]="contactForm.controls['role']"
                            style="
                              width: 178px;
                              height: 30px;
                              line-height: 18px;
                              font-size: 13px;
                              padding: 2px 10px;
                              border: 1px solid #ccc;
                              border-radius: 5px;
                              outline: none;
                              background-color: #e8eaf0;
                              box-sizing: border-box;
                              transition: box-shadow 0.2s ease,
                                border-color 0.2s ease;
                              box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                            "
                            onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                            onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                          >
                            <option value="" disabled>Select</option>
                            <option *ngFor="let role of roles" [value]="role">
                              {{ role }}
                            </option>
                          </select>
                          <div
                            class="error"
                            *ngIf="
                              submitted && contactForm.controls['role'].errors
                            "
                          >
                            Role is required
                          </div>
                        </div>

                        <!-- Other Role Input -->
                        <div *ngIf="showOther" style="margin-top: -3px">
                          <label class="fontSize">Other</label><br />
                          <input
                            type="text"
                            [(ngModel)]="contact_other"
                            [ngModelOptions]="{ standalone: true }"
                            placeholder="Enter Role"
                            [formControl]="
                              contactForm.controls['contact_other']
                            "
                            style="
                              width: 100%;
                              height: 30px;
                              padding: 6px 10px;
                              font-size: 14px;
                              border: 1px solid #ccc;
                              border-radius: 6px;
                              outline: none;
                              background-color: #e8eaf0;
                              box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                              transition: box-shadow 0.2s ease,
                                border-color 0.2s ease;
                              text-transform: capitalize;
                            "
                            onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                            onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                          />
                          <div
                            class="error"
                            *ngIf="
                              submitted &&
                              contactForm.controls['contact_other'].errors
                            "
                          >
                            This field is required
                          </div>
                        </div>
                        <!-- Email Reports -->
                        <div *ngIf="!showOther" style="margin-top: 15px">
                          <label
                            style="
                              display: flex;
                              align-items: center;
                              cursor: pointer;
                            "
                          >
                            <input
                              type="checkbox"
                              [(ngModel)]="emailReports"
                              [ngModelOptions]="{ standalone: true }"
                              style="
                                margin-right: 8px;
                                width: 16px;
                                height: 16px;
                                cursor: pointer;
                              "
                            />
                            <span class="fontSize">Email Reports</span>
                          </label>
                        </div>
                      </div>
                      <!-- Email Reports Checkbox -->
                      <div *ngIf="showOther" style="margin-top: 15px">
                        <label
                          style="
                            display: flex;
                            align-items: center;
                            cursor: pointer;
                          "
                        >
                          <input
                            type="checkbox"
                            [(ngModel)]="emailReports"
                            [ngModelOptions]="{ standalone: true }"
                            style="
                              margin-right: 8px;
                              width: 16px;
                              height: 16px;
                              cursor: pointer;
                            "
                          />
                          <span class="fontSize">Email Reports</span>
                        </label>
                      </div>
                    </form>
                  </div>

                  <!-- Footer Buttons -->
                  <div class="modal-footer">
                    <!-- Cancel Button -->
                    <!-- Cancel-Style Button -->
                    <button
                      class="btn btn-sm fontSize"
                      style="
                        font-size: 13px;
                        padding: 4px 12px;
                        border-radius: 4px;
                        background-color: #ffffff;
                        color: #0b2e67;
                        border: 1px solid #0b2e67;
                        cursor: pointer;
                      "
                      (click)="onCloseAddContactPopup()"
                    >
                      Cancel
                    </button>

                    <!-- Save Button -->
                    <!-- Save-Style Button -->
                    <button
                      class="btn btn-sm fontSize"
                      style="
                        font-size: 14px;
                        padding: 4px 12px;
                        border-radius: 4px;
                        background-color: #142a49;
                        border: 1px solid #142a49;
                        color: #ffffff;
                        border: none;
                        cursor: pointer;
                      "
                      (click)="onSaveContact()"
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- Edit Contact Information Popup -->
            <div
              *ngIf="showContactEditModal"
              class="modal fade show d-block"
              data-bs-backdrop="static"
              id="basicModal1"
              tabindex="-1"
              style="background: rgba(0, 0, 0, 0.5)"
            >
              <div
                style="width: 400px"
                class="modal-dialog modal-dialog-centered"
              >
                <div class="modal-content">
                  <div
                    style="
                      padding: 5px;
                      background-color: #142a49;
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                    "
                  >
                    <!-- <h6 class="modal-title">{{ lang.Add_Contact }}</h6> -->
                    <h6 style="margin: 3px; background-color: #142a49">
                      Edit Contact
                    </h6>
                    <button
                      (click)="onCloseEditPopup()"
                      style="margin: 3px"
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>

                  <div class="modal-body">
                    <form class="onbordingform">
                      <!-- First row -->
                      <div style="display: flex; column-gap: 10px; width: 100%">
                        <!-- first name -->
                        <div>
                          <label class="fontSize">{{ lang.First_Name }}</label
                          ><br />
                          <input
                            type="text"
                            [ngModelOptions]="{ standalone: true }"
                            [(ngModel)]="firstName"
                            [formControl]="contactForm.controls['firstName']"
                            placeholder="{{ lang.First_Name }}"
                            style="
                              width: 100%;
                              height: 30px;
                              padding: 6px 10px;
                              font-size: 14px;
                              border: 1px solid #ccc;
                              border-radius: 6px;
                              outline: none;
                              background-color: #e8eaf0;
                              box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                              transition: box-shadow 0.2s ease,
                                border-color 0.2s ease;
                              text-transform: capitalize;
                            "
                            onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                            onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                          />
                          <div
                            class="error"
                            *ngIf="
                              submitted &&
                              contactForm.controls['firstName'].errors
                            "
                          >
                            First name is required
                          </div>
                        </div>
                        <!-- Last name -->
                        <div>
                          <label class="fontSize">{{ lang.Last_Name }}</label
                          ><br />
                          <input
                            type="text"
                            [ngModelOptions]="{ standalone: true }"
                            [(ngModel)]="lastName"
                            [formControl]="contactForm.controls['lastName']"
                            placeholder="{{ lang.Last_Name }}"
                            style="
                              width: 100%;
                              height: 30px;
                              padding: 6px 10px;
                              font-size: 14px;
                              border: 1px solid #ccc;
                              border-radius: 6px;
                              outline: none;
                              background-color: #e8eaf0;
                              box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                              transition: box-shadow 0.2s ease,
                                border-color 0.2s ease;
                              text-transform: capitalize;
                            "
                            onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                            onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                          />
                          <div
                            class="error"
                            *ngIf="
                              submitted &&
                              contactForm.controls['lastName'].errors
                            "
                          >
                            Last name is required
                          </div>
                        </div>
                      </div>
                      <!-- Second row -->
                      <div style="display: flex; column-gap: 10px; width: 100%">
                        <!-- Email name -->
                        <div>
                          <label class="fontSize">{{ lang.Email }}</label
                          ><br />
                          <input
                            type="text"
                            [ngModelOptions]="{ standalone: true }"
                            [(ngModel)]="email"
                            [formControl]="contactForm.controls['email']"
                            placeholder="{{ lang.Email }}"
                            style="
                              width: 100%;
                              height: 30px;
                              padding: 6px 10px;
                              font-size: 14px;
                              border: 1px solid #ccc;
                              border-radius: 6px;
                              outline: none;
                              background-color: #e8eaf0;
                              box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                              transition: box-shadow 0.2s ease,
                                border-color 0.2s ease;
                              text-transform: lowercase;
                            "
                            onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                            onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                          />
                          <div
                            class="error"
                            *ngIf="
                              submitted && contactForm.controls['email'].errors
                            "
                          >
                            <span
                              *ngIf="
                                contactForm.controls['email'].errors?.required
                              "
                              >Email is required</span
                            >
                            <span
                              *ngIf="
                                contactForm.controls['email'].errors?.email
                              "
                              >Invalid email</span
                            >
                          </div>
                        </div>
                        <!-- PhoneNumber name -->
                        <div>
                          <label class="fontSize">{{ lang.Phone_Number }}</label
                          ><br />
                          <input
                            type="text"
                            [ngModelOptions]="{ standalone: true }"
                            [(ngModel)]="phone"
                            (keydown)="
                              allowOnlyNumbersForPhoneNumber($event, phone)
                            "
                            [formControl]="contactForm.controls['phone']"
                            max="10"
                            placeholder="{{ lang.Phone_Number }}"
                            style="
                              width: 100%;
                              height: 30px;
                              padding: 6px 10px;
                              font-size: 14px;
                              border: 1px solid #ccc;
                              border-radius: 6px;
                              outline: none;
                              background-color: #e8eaf0;
                              box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                              transition: box-shadow 0.2s ease,
                                border-color 0.2s ease;
                              text-transform: capitalize;
                            "
                            onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                            onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                          />
                          <div
                            class="error"
                            *ngIf="
                              submitted && contactForm.controls['phone'].errors
                            "
                          >
                            <span
                              *ngIf="
                                contactForm.controls['phone'].errors?.required
                              "
                            >
                              Phone number is required
                            </span>
                            <span
                              *ngIf="
                                contactForm.controls['phone'].errors?.pattern
                              "
                            >
                              Phone number must be exactly 10 digits
                            </span>
                          </div>
                        </div>
                      </div>
                      <!-- Third row -->
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          /* flex-wrap: wrap; */
                          column-gap: 10px;
                          width: 100%;
                          margin-top: 2px;
                        "
                      >
                        <!-- Roles -->
                        <div style="display: flex; flex-direction: column">
                          <label class="fontSize">Roles</label>
                          <select
                            [(ngModel)]="role"
                            [ngModelOptions]="{ standalone: true }"
                            (change)="onRoleChange($event)"
                            [formControl]="contactForm.controls['role']"
                            style="
                              width: 178px;
                              height: 30px;
                              line-height: 18px;
                              font-size: 13px;
                              padding: 2px 10px;
                              border: 1px solid #ccc;
                              border-radius: 5px;
                              outline: none;
                              background-color: #e8eaf0;
                              box-sizing: border-box;
                              transition: box-shadow 0.2s ease,
                                border-color 0.2s ease;
                              box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                            "
                            onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                            onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                          >
                            <option *ngFor="let role of roles" [value]="role">
                              {{ role }}
                            </option>
                          </select>
                          <div
                            class="error"
                            *ngIf="
                              submitted && contactForm.controls['role'].errors
                            "
                          >
                            Role is required
                          </div>
                        </div>

                        <div *ngIf="showOther" style="margin-top: -3px">
                          <label class="fontSize">Other</label><br />
                          <input
                            type="text"
                            [(ngModel)]="contact_other"
                            [ngModelOptions]="{ standalone: true }"
                            [formControl]="
                              contactForm.controls['contact_other']
                            "
                            placeholder="Enter Role"
                            style="
                              width: 100%;
                              height: 30px;
                              padding: 6px 10px;
                              font-size: 14px;
                              border: 1px solid #ccc;
                              border-radius: 6px;
                              outline: none;
                              background-color: #e8eaf0;
                              box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
                              transition: box-shadow 0.2s ease,
                                border-color 0.2s ease;
                              text-transform: capitalize;
                            "
                            onfocus="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.12)'; this.style.borderColor='#6c757d';"
                            onblur="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.08)'; this.style.borderColor='#ccc';"
                          />
                          <div
                            class="error"
                            *ngIf="
                              submitted &&
                              contactForm.controls['contact_other'].errors
                            "
                          >
                            Other role is required
                          </div>
                        </div>
                        <div *ngIf="!showOther" style="margin-top: 15px">
                          <label
                            style="
                              display: flex;
                              align-items: center;
                              cursor: pointer;
                            "
                          >
                            <input
                              type="checkbox"
                              [(ngModel)]="emailReports"
                              [ngModelOptions]="{ standalone: true }"
                              style="
                                margin-right: 8px;
                                width: 16px;
                                height: 16px;
                                cursor: pointer;
                              "
                            />
                            <span class="fontSize">Email Reports</span>
                          </label>
                        </div>
                      </div>
                      <div *ngIf="showOther" style="margin-top: 15px">
                        <label
                          style="
                            display: flex;
                            align-items: center;
                            cursor: pointer;
                          "
                        >
                          <input
                            type="checkbox"
                            [(ngModel)]="emailReports"
                            [ngModelOptions]="{ standalone: true }"
                            style="
                              margin-right: 8px;
                              width: 16px;
                              height: 16px;
                              cursor: pointer;
                            "
                          />
                          <span class="fontSize">Email Reports</span>
                        </label>
                      </div>
                    </form>
                  </div>
                  <!-- close and save button -->
                  <div style="margin: -7px" class="modal-footer">
                    <!-- Close Button -->
                    <button
                      class="btn btn-sm fontSize"
                      style="
                        font-size: 14px;
                        padding: 4px 12px;
                        border-radius: 4px;
                        background-color: white;
                        border: 1px solid #142a49;
                        color: #142a49;
                        cursor: pointer;
                      "
                      (click)="onCloseEditPopup()"
                    >
                      Cancel
                    </button>

                    <!-- Save Button -->
                    <button
                      class="btn btn-sm fontSize"
                      style="
                        font-size: 14px;
                        padding: 4px 12px;
                        border-radius: 4px;
                        background-color: #142a49;
                        border: 1px solid #142a49;
                        color: #ffffff;
                        border: none;
                        cursor: pointer;
                      "
                      (click)="
                        onUpdateContact(selectedIndex, selectedSupplierId)
                      "
                    >
                      Update
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Footer -->
            <div class="modal-footer">
              <button
                class="btn btn-sm"
                style="
                  font-size: 13px;
                  padding: 4px 12px;
                  border-radius: 4px;
                  background-color: #ffffff;
                  color: #142a49;
                  border: 1px solid #142a49;
                "
                (click)="closeModal()"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Product List Popup -->
      <div
        *ngIf="showProductModal"
        class="modal"
        tabindex="-1"
        style="display: block; background: rgba(0, 0, 0, 0.5)"
      >
        <div class="modal-dialog modal-lg" style="margin-top: 120px">
          <div class="modal-content">
            <!-- Header -->
            <div class="modal-header">
              <h5 class="modal-title" style="font-size: 15px; font-weight: 500">
                Product List
              </h5>
              <button
                type="button"
                class="custom-close-btn"
                (click)="closeModal()"
                aria-label="Close"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill="white"
                    d="M2.146 2.146a.5.5 0 0 1 .708 0L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854a.5.5 0 0 1 0-.708z"
                  />
                </svg>
              </button>
            </div>

            <!-- Body -->
            <div class="modal-body p-3">
              <!-- Button Row -->
              <div
                style="
                  display: flex;
                  justify-content: flex-end;
                  margin-bottom: 2px;
                "
              >
                <button
                  class="btn btn-success btn-sm"
                  style="
                    font-size: 13px;
                    padding: 4px 12px;
                    border-radius: 4px;
                    background-color: #fff;
                    color: #142a49;
                  "
                  (click)="openModalForAddNewProduct()"
                >
                  + Add New
                </button>
              </div>
              <div class="table-responsive">
                <table
                  style="
                    width: 100%;
                    border-collapse: collapse;
                    font-family: Arial, sans-serif;
                    border: 1px solid #b9b9b9;
                    font-size: 12px;
                  "
                >
                  <thead>
                    <tr
                      style="
                        background-color: #808285;
                        color: white;
                        height: 29px;
                      "
                    >
                      <th
                        style="text-align: left; padding: 2px 8px; width: 16%"
                      >
                        Product ID
                      </th>
                      <th
                        style="text-align: left; padding: 2px 8px; width: 20%"
                      >
                        Name
                      </th>
                      <th
                        style="text-align: left; padding: 2px 8px; width: 20%"
                      >
                        Effective Date
                      </th>
                      <th
                        style="text-align: left; padding: 2px 8px; width: 20%"
                      >
                        Country
                      </th>
                      <th
                        style="text-align: left; padding: 2px 8px; width: 15%"
                      >
                        Actions
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      *ngFor="let product of products; let i = index"
                      style="
                        background-color: #f6f6f6;
                        height: 29px;
                        font-size: 14px;
                      "
                    >
                      <td style="text-align: left; padding: 2px 8px">
                        {{ product?.productInfo?.productId }}
                      </td>
                      <td style="text-align: left; padding: 2px 8px">
                        {{ product?.productInfo?.productName }}
                      </td>
                      <td style="text-align: left; padding: 2px 8px">
                        {{ product?.productInfo?.effectiveDistributionDate }}
                      </td>
                      <td style="text-align: left; padding: 2px 8px">
                        {{ product?.productInfo?.productCountry[0]?.name }}
                      </td>
                      <td style="text-align: left; padding: 2px 8px">
                        <button
                          (click)="openSingleProductModal(product, 'view')"
                          style="
                            background-color: #142a49;
                            border: none;
                            border-radius: 6px;
                            cursor: pointer;
                            margin-right: 5px;
                            color: white;
                            padding: 2px 8px;
                            font-size: 12px;
                          "
                        >
                          <i class="bi bi-eye-fill"></i>
                        </button>
                        <button
                          (click)="openSingleProductModal(product, 'edit')"
                          style="
                            background-color: #2ca46c;
                            border: none;
                            border-radius: 6px;
                            cursor: pointer;
                            margin-right: 5px;
                            color: white;
                            padding: 2px 8px;
                            font-size: 12px;
                          "
                        >
                          <i class="bi bi-pencil-fill"></i>
                        </button>

                        <button
                          (click)="
                            triggerDeleteProductModal(
                              product.productInfo.productId,
                              product.productInfo.productName
                            )
                          "
                          style="
                            background-color: #b31616;
                            border: none;
                            border-radius: 6px;
                            cursor: pointer;
                            color: white;
                            padding: 2px 8px;
                            font-size: 12px;
                          "
                        >
                          <i class="bi bi-trash-fill"></i>
                        </button>
                      </td>
                    </tr>

                    <!-- No data fallback -->
                    <tr *ngIf="products.length === 0" style="height: 29px">
                      <td colspan="5" style="padding: 4px 8px; color: #333">
                        No Products Available!
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Footer -->
            <div class="modal-footer">
              <button
                class="btn btn-sm"
                style="
                  font-size: 13px;
                  padding: 4px 12px;
                  border-radius: 4px;
                  background-color: #ffffff;
                  color: #142a49;
                  border: 1px solid #142a49;
                "
                (click)="closeModal()"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Update Product -->
      <!-- <app-update-supplier
        *ngIf="showSingleProductModal"
        [productData]="selectedProduct"
        [selectedSupplierId]="selectedSupplierId"
        (refreshParentData)="refreshParentData()"
        [productModalMode]="productModalMode"
        [editOrUpdate]="'Update Section'"
        (onClose)="showSingleProductModal = false"
        (onSave)="handleUpdate($event)"
      >
      </app-update-supplier> -->

      <!-- Edit Product -->
      <app-edit-supplier-product
        *ngIf="showSingleProductModal"
        [productData]="selectedProduct"
        [selectedSupplierId]="selectedSupplierId"
        [productModalMode]="productModalMode"
        [editOrUpdate]="'Update Section'"
        [productId] = "selectedProduct.productInfo.productId"
        (onClose)="showSingleProductModal = false"
        (onSave)="handleUpdate($event)"
        (refreshParentData)="refreshParentData()"
      >
      </app-edit-supplier-product>

      <!-- ADD NEW PRODUCT -->
       <app-edit-supplier-product
        *ngIf="showModalToAddNewProduct"
        [productData]="selectedProduct"
        [selectedSupplierId]="selectedSupplierId"
        [productModalMode]="productModalMode"
        [editOrUpdate]="'Add Section'"
        [productId] = "selectedProduct.productInfo.productId"
        (onClose)="showModalToAddNewProduct = false"
        (onSave)="handleUpdate($event)"
        (refreshParentData)="refreshParentData()"
      >
      </app-edit-supplier-product>

      <!-- Add New Product -->
      <!-- <app-add-newproduct-supplier
        *ngIf="showModalToAddNewProduct"
        [productData]="selectedProduct"
        (refreshParentData)="refreshParentData()"
        [selectedSupplierId]="selectedSupplierId"
        (onClose)="showModalToAddNewProduct = false"
        (onSave)="handleUpdate($event)"
      >
      </app-add-newproduct-supplier> -->
      
      <!-- Delete Contact Modal -->
      <div
        *ngIf="showConfirmationContactDelete"
        style="
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background-color: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 9999;
        "
      >
        <div
          style="
            width: 400px;
            background-color: white;
            border-radius: 8px;
            overflow: hidden;
            font-family: Arial, sans-serif;
            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
          "
        >
          <!-- Header -->
          <div
            style="
              background-color: #142a49;
              color: white;
              font-weight: bold;
              padding: 10px 16px;
              font-size: 16px;
              text-align: center;
            "
          >
            Alert
          </div>

          <!-- Message -->
          <div style="padding: 20px; font-size: 15px; text-align: center">
            <p style="margin: 0">
              Are you sure you want to delete this Contact?
            </p>
            <p style="margin-top: 8px; font-weight: bold">
              {{ contactNameForDelete }}
            </p>
          </div>

          <!-- Buttons -->
          <div
            style="
              display: flex;
              justify-content: center;
              padding: 0 0 14px 0;
              gap: 12px;
            "
          >
            <button
              (click)="deleteContact()"
              class="btn btn-sm"
              style="
                font-size: 13px;
                padding: 4px 12px;
                border-radius: 4px;
                background-color: #142a49;
                color: #ffffff;
                border: none;
                cursor: pointer;
              "
            >
              Proceed
            </button>
            <button
              (click)="showConfirmationContactDelete = false"
              class="btn btn-sm"
              style="
                font-size: 13px;
                padding: 4px 12px;
                border-radius: 4px;
                background-color: #ffffff;
                color: #0b2e67;
                border: 1px solid #0b2e67;
                cursor: pointer;
              "
            >
              Cancel
            </button>
          </div>
        </div>
      </div>

      <!-- Delete Supplier Confirmation Modal -->
      <div
        *ngIf="showDeleteSupplierConfirm"
        style="
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background-color: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 9999;
        "
      >
        <div
          style="
            width: 400px;
            background-color: white;
            border-radius: 8px;
            overflow: hidden;
            font-family: Arial, sans-serif;
            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
          "
        >
          <!-- Header -->
          <div
            style="
              background-color: #142a49;
              color: white;
              font-weight: bold;
              padding: 10px 16px;
              font-size: 16px;
              text-align: center;
            "
          >
            Alert
          </div>

          <!-- Message -->
          <div style="padding: 20px; font-size: 15px; text-align: center">
            <p style="margin: 0">
              Are you sure you want to delete this Supplier?
            </p>
            <p style="margin-top: 8px; font-weight: bold">
              {{ selectedSingleSupplier.name }}
            </p>
          </div>

          <!-- Buttons -->
          <div
            style="
              display: flex;
              justify-content: center;
              padding: 0 0 14px 0;
              gap: 12px;
            "
          >
            <button
              (click)="onConfirmDeleteSupplier(selectedSingleSupplier)"
              class="btn btn-sm"
              style="
                font-size: 13px;
                padding: 4px 12px;
                border-radius: 4px;
                background-color: #142a49;
                color: #ffffff;
                border: none;
                cursor: pointer;
              "
            >
              Proceed
            </button>
            <button
              (click)="showDeleteSupplierConfirm = false"
              class="btn btn-sm"
              style="
                font-size: 13px;
                padding: 4px 12px;
                border-radius: 4px;
                background-color: #ffffff;
                color: #0b2e67;
                border: 1px solid #0b2e67;
                cursor: pointer;
              "
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
      <!-- Delete Product Confirmation Modal -->
      <div
        *ngIf="showDeleteProductConfirm"
        style="
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background-color: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 9999;
        "
      >
        <div
          style="
            width: 400px;
            background-color: white;
            border-radius: 8px;
            overflow: hidden;
            font-family: Arial, sans-serif;
            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
          "
        >
          <!-- Header -->
          <div
            style="
              background-color: #142a49;
              color: white;
              font-weight: bold;
              padding: 10px 16px;
              font-size: 16px;
              text-align: center;
            "
          >
            Alert
          </div>

          <!-- Message -->
          <div style="padding: 20px; font-size: 15px; text-align: center">
            <p style="margin: 0">
              Are you sure you want to delete this Product?
            </p>
            <p style="margin-top: 8px; font-weight: bold">
              {{ productNameForDelete }}
            </p>
          </div>

          <!-- Buttons -->
          <div
            style="
              display: flex;
              justify-content: center;
              padding: 0 0 14px 0;
              gap: 12px;
            "
          >
            <button
              (click)="
                onConfirmDeleteProduct(productIDForDelete, selectedSupplierId)
              "
              class="btn btn-sm"
              style="
                font-size: 13px;
                padding: 4px 12px;
                border-radius: 4px;
                background-color: #142a49;
                color: #ffffff;
                border: none;
                cursor: pointer;
              "
            >
              Proceed
            </button>
            <button
              (click)="showDeleteProductConfirm = false"
              class="btn btn-sm"
              style="
                font-size: 13px;
                padding: 4px 12px;
                border-radius: 4px;
                background-color: #ffffff;
                color: #0b2e67;
                border: 1px solid #0b2e67;
                cursor: pointer;
              "
            >
              Cancel
            </button>
          </div>
        </div>
      </div>

      <!-- *******************************************End************************************************* -->
    </div>
  </div>
</main>

<!-- create supplier component -->
<!-- <app-create-supplier
  *ngIf="showCreateSupplier"
  mode="create"
        (refreshParentDataForCreateSupplier)="refreshParentDataForCreateSupplier()"
  [existingSuppliers]="existingSuppliers"
  (onClose)="toggleCreateSupplier(false)"
></app-create-supplier> -->

<!-- Update Entire supplier component -->
<!-- <app-create-supplier
*ngIf="showComponentForUpdateEntireSupplier"
mode="update"
        (refreshParentDataForCreateSupplier)="refreshParentDataForCreateSupplier()"
        [supplierData]="selectedSingleSupplierData"
  [existingSuppliers]="existingSuppliers"
  (onClose)="toggleCreateSupplier(false)"
></app-create-supplier> -->
